import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { WhatsAppButton, BookButton } from "../components/CTAButtons";
import { ALL_SERVICES, BRAND } from "../data/content";
import { breadcrumbSchema, multiGraph } from "../components/Schema";

export default function ServicesIndex({ onBook }) {
  const crumbs = [
    { label: "Home", href: "/" },
    { label: "Spa services in Bhubaneswar" },
  ];
  return (
    <>
      <Seo
        title="Spa services in Bhubaneswar"
        description="The full spa & massage menu available in Bhubaneswar — Swedish, deep tissue, aroma, Thai, Balinese, hot stone, jacuzzi, couples, and the Zorba Signature 6-in-1 experience. Transparent prices."
        path="/spa-services-bhubaneswar/"
        jsonLd={multiGraph(breadcrumbSchema(crumbs))}
      />
      <section className="content-hero section-pad narrow">
        <Breadcrumbs items={crumbs} />
        <p className="eyebrow">{BRAND.short}</p>
        <h1>Spa services in Bhubaneswar</h1>
        <p className="large-copy">
          The full menu from our featured partner, Zorba International Spa — 18 services spanning classic massage,
          traditional techniques, warm-water hydrotherapy and the signature 6-in-1 wellness experience. Prices are
          published transparently.
        </p>
        <div className="actions-row">
          <BookButton onBook={onBook} label="Start enquiry" testid="services-index-book" />
          <WhatsAppButton label="Ask on WhatsApp" source="services_index" testid="services-index-whatsapp" />
        </div>
      </section>
      <section className="section-pad">
        <div className="service-grid three">
          {ALL_SERVICES.map((s, i) => (
            <Link to={`/services/${s.slug}/`} className="service-card" key={s.slug} data-testid={`services-index-card-${i}`}>
              <div className="service-photo" style={{ backgroundImage: `url(${s.image})` }} />
              <div className="service-card-copy">
                <span className="card-kicker">{s.kicker}</span>
                <h3>{s.name}</h3>
                <p>{s.short}</p>
                <div className="service-price-row">
                  <span>{s.priceOptions[0].duration} · {s.priceOptions[0].display}</span>
                  <ArrowRight size={18} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
